var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 15 15",
    fill: "#3B3B58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B3B58",
    d: "M3 1.15a1.5 1.5 0 1 1 2.903.757A1.5 1.5 0 0 1 3 1.15zm11 11.17a1 1 0 0 1-.796 1.17H13.2a1 1 0 0 1-1.07-.49l-1.68-3.37L9 9.92l-.22.08h-.06v2.15l.62-.15h.14a.52.52 0 0 1 .19 1l-5 1a.51.51 0 0 1-.17 0a.52.52 0 0 1-.2-1l4.15-.83V10l-3.22.58a1 1 0 0 1-1.21-.68H4L3 5.83a1 1 0 0 1 0-.43a1 1 0 0 1 .8-.75l4.7-.52V0h.22v4.1h.06L9 4.08L9.4 4h.21a.5.5 0 0 1 .37.6a.49.49 0 0 1-.49.4L9 5.08h-.28v2.86h.06L9 7.88l1.81-.36a1 1 0 0 1 1 .6l2 3.94a.999.999 0 0 1 .19.26zM8.5 5.13L6 5.4l.74 2.94L8.5 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.7f1f8dcd1df245549232a187af59bcc0.svg";
export { ForwardRef as ReactComponent };